import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';



const rows = [
  { id: 1, title: 'Iron Man', company: 'Marvel', director: 'Jon Favreau', year: 2008, cinematicUniverse: 'Marvel Cinematic Universe' },
  { id: 2, title: 'The Dark Knight', company: 'Warner Bros', director: 'Christopher Nolan', year: 2008, cinematicUniverse: 'DC Universe' },
  { id: 3, title: 'Avengers: Endgame', company: 'Marvel', director: 'Anthony Russo', year: 2019, cinematicUniverse: 'Marvel Cinematic Universe' },
  { id: 4, title: 'Wonder Woman', company: 'Warner Bros', director: 'Patty Jenkins', year: 2017, cinematicUniverse: 'DC Universe' },
  { id: 5, title: 'Guardians of the Galaxy', company: 'Marvel', director: 'James Gunn', year: 2014, cinematicUniverse: 'Marvel Cinematic Universe' },
];

const columns = [
  { field: 'title', headerName: 'Title', width: 150 },
  { field: 'company', headerName: 'Company', width: 150 },
  { field: 'director', headerName: 'Director', width: 150 },
  { field: 'year', headerName: 'Year', type: 'number', width: 110 },
  { field: 'cinematicUniverse', headerName: 'Cinematic Universe', width: 200 },
];

export default function QuickFilteringGrid() {
  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
      />
    </Box>
  );
}
